import { render, staticRenderFns } from "./HistoryOff.vue?vue&type=template&id=6ef8ed92&scoped=true&"
import script from "./HistoryOff.vue?vue&type=script&lang=js&"
export * from "./HistoryOff.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOff.vue?vue&type=style&index=0&id=6ef8ed92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef8ed92",
  null
  
)

export default component.exports